import { Box, CircularProgress, Typography } from "@mui/material";
import "./LoadingSpinner.css";

const LoadingSpinner = ({
    size = 48,
    thickness = 4,
    color = "primary",
    overlay = false,
    label,
    className = "",
    ...props
}) => {

    const spinner = (
        <Box
            className={`loading-spinner ${className}`}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            {...props}
        >
            <CircularProgress
                size={size}
                thickness={thickness}
                color={color}
            />
            {label && (
                <Typography
                    variant="body1"
                    
                    className="loading-label"
                    sx={{ mt: 1 }}
                >
                    {label}
                </Typography>
            )}
        </Box>
    );

    if (overlay) {
        return (
            <Box className="loading-overlay">
                {spinner}
            </Box>
        );
    }

    return spinner;
};

export default LoadingSpinner;
